
import * as Configuration from '../../../app.constants.js';

export class SiteGroupsService {
  constructor($http, $q, $translate, $state) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
    this.$state = $state;
  }

  createSiteGroup(companyId, name, platform) {
    return this.$http.post(
      Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/site-group',
      {
        name: name,
        type: platform
      });
  }

  updateSiteGroup(companyId, siteGroupId, name, siteIds) {
    let data = {
      name: name,
      site_ids: siteIds
    };

    return this.$http.put(Configuration.constants.baseUrl + 'api/2.0/companies/' + companyId + '/site-group/' + siteGroupId, data);
  }

  hrefGroupInfo(siteGroupId) {
    return Configuration.constants.frontendBaseUrl + this.$state.href('auth.alcmeon.fuse.site-group-edit', this.$state.params) + siteGroupId;
  }

  deleteEmptyGroup(companyId, siteGroupId) {
    return this.$http.delete(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/site-group/' + siteGroupId);
  }

  redirectToGroupsPage() {
    this.$state.go('auth.alcmeon.fuse.parameters.accounts', {
      companyId: this.$state.params.companyId,
      selectedTabIndex: 1
    });
  }

  static SitesGroupFactory($http, $q, $translate, $state) {
    return new SiteGroupsService($http, $q, $translate, $state);
  }
}

SiteGroupsService.SitesGroupFactory.$inject = ['$http', '$q', '$translate', '$state'];
